import { navigateTo } from '@mfl/framework';
import { prompt, PromptResult } from '@mfl/common-components';
import {
  PURCHASE_PLANS_URL,
  reportUserAnalyticEvent,
} from '@mfl/platform-shell';

// Matches @mfl/platform-shell global-navigation.strings upgrade copy
const UPGRADE_MODAL_TITLE = 'Upgrade account';
const UPGRADE_MODAL_STATEMENT = 'Upgrade your account to access this feature';

export async function openNavUpgradeModal(origin: string): Promise<boolean> {
  void reportUserAnalyticEvent({
    eventName: 'upgrade_modal_shown',
    metadata: { origin },
  });

  const confirmResult = await prompt({
    aid: 'UPGRADE_PROMPT_FROM_NAV_BAR',
    header: UPGRADE_MODAL_TITLE,
    question: UPGRADE_MODAL_STATEMENT,
    primaryButtonText: 'Upgrade',
    secondaryButtonText: 'Cancel',
  });

  void reportUserAnalyticEvent({
    eventName: 'navigated_to_pricing_page',
    metadata: { origin, confirmResult },
  });

  if (confirmResult === PromptResult.Primary) navigateTo(PURCHASE_PLANS_URL);

  return false;
}
